import { Action } from "@ngrx/store";
import { CompanyPageMeta } from "../models/company-page-store.model";

export const SET_COMPANY_PAGE_META = "SET_COMPANY_PAGE_META";

export class SetCompanyPageMeta implements Action {
  readonly type = SET_COMPANY_PAGE_META;
  constructor(
    public payload: {
      ticker: string;
      value: CompanyPageMeta;
    },
  ) {}
}

export type Actions = SetCompanyPageMeta;
